export default __webpack_public_path__ + "static/media/pizza-hunt.7f483074.jpg";